// extracted by mini-css-extract-plugin
module.exports = {"about":"o-nas-module--about--3avqi","aboutText":"o-nas-module--aboutText--1RQU1","aboutImage":"o-nas-module--aboutImage--3xTOF"};